import { Routes, Route, Navigate } from "react-router-dom";
import React from "react";
import SignIn from "../pages/auth/SignIn";
import ForgotPassword from "../pages/auth/ForgotPasswordMail";
import ResetPassword from "../pages/auth/ResetPassword";
import SignUpConfirmation from "../pages/auth/SignUpConfirmation";
import DashBoard from "../pages/DashBoard";
import CreateMembers from "../pages/members/CreateMemberPage";
import Members from "../pages/members/MemberHomePage";
import MemberLabel from "../pages/members/PrintMemberLabel";
import SendEmailPage from "../pages/members/SendEmailPage";
import Order from "../pages/order/Order";
import CreateOrder from "../components/Order/CreateOrder";
import UpdatePayment from "../components/Order/UpdatePayment";
// import CreateEvent from "../components/Events/CreateEvent1";
import EventsHomePage from "../pages/events/EventsHomePage";
import Invoice from "../pages/invoice/Invoice";
import Reports from "../pages/reports/Reports";
import Configuration from "../pages/configurations/Configuration";
// import Home from "../pages/home/Home";
import * as routeConfig from "../config/routes";
import PrivateRoute from "../privateRoutes";
import MemberDetail from "../components/MemberDetail/MemberDetail";
import FindMember from "../components/FindMember/FindMember";
import FMSavedSearchList from "../components/FindMember/FMSavedSearchList";
import ViewOrder from "../components/Order/ViewOrder";
import ViewEvent from "../components/Events/ViewEvent";
import CreateEvent from "../components/Events/CreateEvent";
import CreateVideoEvent from "../components/Events/CreateVideoEvent";
import EditEvent from "../components/Events/EditEvent";
import FindMemberListSavedQuery from "../components/FindMember/FindMemberListSavedQuery";
import JobScreen from "../components/reports/JobScreen";
import PrintMemberDetail from "../pages/members/PrintMemberDetail";
import PositionsPage from "../pages/positions/PositionsPage";
import CommitteesPage from "../pages/committees/CommitteesPage";

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path={routeConfig.SIGN_IN_URL} element={<SignIn />} />
      <Route
        path={routeConfig.FORGOT_PASSWORD_URL}
        element={<ForgotPassword />}
      />
      <Route path={routeConfig.RESET_PASSWORD} element={<ResetPassword />} />
      <Route
        path={routeConfig.SIGN_UP_CONFIRMATION}
        element={<SignUpConfirmation />}
      />
      <Route path="/" element={<DashBoard />}>
        <Route path="/" element={<PrivateRoute component={FindMember} />} />
        <Route
          path={routeConfig.MEMBERS_URL}
          element={<PrivateRoute component={Members} />}
        />
        <Route
          path={routeConfig.MEMBER_DETAIL_URL}
          element={<PrivateRoute component={MemberDetail} />}
        />
        <Route
          path={routeConfig.ORDER_DETAIL_URL}
          element={<PrivateRoute component={ViewOrder} />}
        />
        <Route
          path={routeConfig.FIND_MEMBER_URL}
          element={<PrivateRoute component={FindMember} />}
        />
        <Route
          path={routeConfig.MEMBERS_SAVEDSEARCH_URL}
          element={<PrivateRoute component={FMSavedSearchList} />}
        />
        <Route
          path={routeConfig.MEMBER_SAVED_SEARCH_URL}
          element={<PrivateRoute component={FindMemberListSavedQuery} />}
        />
        <Route
          path={routeConfig.CREATE_MEMBERS_URL}
          element={<PrivateRoute component={CreateMembers} />}
        />
        <Route
          path={routeConfig.MEMBER_EMAIL}
          element={<PrivateRoute component={SendEmailPage} />}
        />
        <Route
          path={routeConfig.MEMBER_LABEL_URL}
          element={<PrivateRoute component={MemberLabel} />}
        />
        <Route
          path={routeConfig.ORDER_URL}
          element={<PrivateRoute component={Order} />}
        />
        {/* <Route
          path={routeConfig.CREATE_ORDER_URL}
          element={<PrivateRoute component={CreateOrder} />}
        /> */}
        <Route
          path={routeConfig.UPDATE_PAYMENT_URL}
          element={<PrivateRoute component={UpdatePayment} />}
        />
        <Route
          path={routeConfig.EVENT_URL}
          element={<PrivateRoute component={EventsHomePage} />}
        />
        <Route
          path={routeConfig.EVENT_DETAIL_URL}
          element={<PrivateRoute component={ViewEvent} />}
        />
        <Route
          path={routeConfig.CREATE_EVENT_URL}
          element={<PrivateRoute component={CreateEvent} />}
        />
        <Route
          path={routeConfig.EDIT_EVENT_URL}
          element={<PrivateRoute component={EditEvent} />}
        />
        <Route
          path={routeConfig.CREATE_VIDEO_EVENT_URL}
          element={<PrivateRoute component={CreateVideoEvent} />}
        />
        <Route
          path={routeConfig.INVOICE_URL}
          element={<PrivateRoute component={Invoice} />}
        />
        <Route
          path={routeConfig.REPORT_URL}
          element={<PrivateRoute component={Reports} />}
        />
        <Route
          path={routeConfig.JOB_URL}
          element={<PrivateRoute component={JobScreen} />}
        />
        <Route
          path={routeConfig.SETTINGS_URL}
          element={<PrivateRoute component={Configuration} />}
        />

        <Route
          path={routeConfig.MEMBER_DETAIL_URL}
          element={<PrivateRoute component={MemberDetail} />}
        />

        <Route
          path={routeConfig.PRINT_MEMBER_URL}
          element={<PrivateRoute component={PrintMemberDetail} />}
        />

        <Route
          path={routeConfig.POSITIONS_URL}
          element={<PrivateRoute component={PositionsPage} />}
        />

        <Route
          path={routeConfig.COMMITTEES_URL}
          element={<PrivateRoute component={CommitteesPage} />}
        />

        <Route path={"*"} element={<Navigate to="/member" />} />
      </Route>
    </Routes>
  );
};

export default AppRoutes;
